import { compareAsc } from 'date-fns';

export const compareDates = (date1?: Date, date2?: Date): number => {
  if (date1 === undefined && date2 === undefined)
    return 0;
  else if (date1 === undefined)
    return -1;
  else if (date2 === undefined)
    return 1;
  return compareAsc(date1, date2);
}
